var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10753 4.30416C9.37962 4.03208 9.82077 4.03208 10.0929 4.30416L15.7961 10.0074C16.0682 10.2795 16.0682 10.7207 15.7961 10.9928L10.0929 16.696C9.82077 16.9681 9.37962 16.9681 9.10753 16.696L3.40426 10.9928C3.13217 10.7207 3.13217 10.2795 3.40426 10.0074L9.10753 4.30416Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant);
export default __webpack_public_path__ + "static/media/variant.256745a2eeaefa3e1f4297cca617853b.svg";
export { ForwardRef as ReactComponent };